import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem } from '@src/services/interface';
import TopicText from '@src/mobile/article/layout/content/components/topicText';
import PreText from '@src/mobile/article/layout/content/components/preText';
import ShortVideo from '@src/mobile/components/shortVideo';
import Pics from '@src/mobile/components/pics';
import Vote from '@src/mobile/components/vote';
import Tweet from '@src/mobile/components/tweet';
import VotePerson from '@src/mobile/article/layout/content/components/votePerson';
import { getQuery } from '@src/utils';

type ShortContentProps = {
    content: FeedFlowItem | null;
};

const ShortContent = ({ content }: ShortContentProps) => {
    const topicData = {
        text: content?.topicTitle,
        topicId: content?.topicId,
    };
    const preTextData = {
        hasContent: content?.post?.hasContent,
        text: content?.post?.text?.content || '',
    };
    const videoData = {
        isFeed: false,
        hasVideo: content?.post?.hasVideo,
        video: content?.post?.video,
    };
    const picsData = {
        list: (content?.post?.hasImage && content?.post?.images) || [],
        isComment: false,
    };
    const voteData = {
        isFeed: false,
        hasVote: content?.post?.hasVote,
        vote: content?.post?.vote,
        type: content?.type,
        callAppData: {
            docType: 'flutter',
            pid: `/detail?id=${content?.id}&ref=outside`,
            kind: 'inter_txs02',
            noKindFrom: 1,
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1381165089725',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8988	',
        },
    };
    const tweetData = {
        isFeed: false,
        forwardStatus: content?.forwardStatus,
        forwardItem: content?.forwardItem?.forwardList?.[0],
        post: content?.post,
        type: content?.type,
    };
    const votePersonData = {
        vote: content?.post?.vote,
        userId: getQuery(location.href, 'userId'),
    };

    return (
        <>
            <TopicText content={topicData} />
            <PreText content={preTextData} />
            <ShortVideo content={videoData} />
            <div className={styles.picBox}>
                <Pics content={picsData} />
            </div>
            <Vote content={voteData} />
            <Tweet content={tweetData} />
            <VotePerson content={votePersonData} />
        </>
    );
};

export default errorBoundary(ShortContent);
